export type ActionNoticeTone = "success" | "error" | "info";

/** Sichtbarer Präfix, damit Erfolg, Fehler und Hinweis nicht nur über die Farbe gehen. */
export function noticePrefix(tone: ActionNoticeTone): string {
  if (tone === "success") return "Gespeichert:";
  if (tone === "error") return "Fehler:";
  return "Hinweis:";
}

export function noticeSpokenText(tone: ActionNoticeTone, text: string): string {
  return `${noticePrefix(tone)} ${text}`;
}

/**
 * iOS liest accessibilityLiveRegion nicht zuverlässig.
 * Die Ansage läuft nur dort, und nur solange eine Meldung da ist.
 */
export function announceNoticeIfNeeded(
  platform: string,
  message: string | null,
  announce: (message: string) => void,
): void {
  if (platform !== "ios" || !message) return;
  announce(message);
}
